import moment, { Moment } from 'moment'
import { ICalendar, IDate } from 'pages/my-calendars/add-calendar'

export const getFilteredApprovedDates = (
    approvedData: ICalendar[],
    worksheetData: ICalendar[],
    locationId?: number,
    calendarId?: string
) => {
    const locationIdStr = locationId ? locationId.toString() : ''
    const filteredApprovedDates: IDate[][] = []
    const startOfTheYear = new Date(new Date().getFullYear(), 0, 1)
    const calendars: ICalendar[] = [...approvedData, ...worksheetData] ?? []
    const filteredCalendars = calendars.filter((calendar) => calendar.id !== calendarId)

    filteredCalendars.forEach((calendar) => {
        const dates = calendar.dates.filter(
            (date) =>
                date.locationId === locationIdStr && new Date(date.createdAt) >= startOfTheYear
        )
        filteredApprovedDates.push(dates)
    })
    return { filteredApprovedDates }
}

export const getEnumerateDaysBetweenDates = (startDate: string, endDate: string) => {
    const dates: Date[] = []

    if (!startDate || !endDate) {
        return []
    }

    const firstDate = moment(startDate).startOf('day')
    const lastDate = moment(endDate).startOf('day')

    while (firstDate.isSameOrBefore(lastDate)) {
        dates.push(firstDate.clone().toDate())
        firstDate.add(1, 'days')
    }

    return dates
}

export const getDisableFilteredDates = (filteredDates: IDate[][]) => {
    const disableFilteredDates: Date[][] = []

    filteredDates.forEach((dates) => {
        dates.forEach((date) => {
            const disableDates = getEnumerateDaysBetweenDates(
                date.lastOrderDate,
                date.firstOrderDate
            )
            disableFilteredDates.push(disableDates)
        })
    })

    return { disableFilteredDates }
}

export const isApprovedFilteredDates = (
    disableFilteredDates: Date[][],
    currentDate: Moment,
    lastOrderDate?: Moment
) => {
    const flatDates = disableFilteredDates.flat(Infinity) as Date[]
    const momentDates = flatDates.map((date) => moment(date))

    let isDisabled = false
    const today = moment().startOf('day')

    // проверка вложенности старого календаря в новом
    if (lastOrderDate && !lastOrderDate.isSame(today, 'day')) {
        isDisabled = momentDates.some((date) => date.isBetween(lastOrderDate, currentDate))
    }

    const isApprovedDates =
        isDisabled || (currentDate && momentDates.some((date) => date.isSame(currentDate, 'day')))

    return { isApprovedDates }
}
